/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import nr from "../../../images/ecoalliance-community.png";
import is from "../../../images/creative-community.png";
import cb from "../../../images/itsnoissue-community.png";
import bt from "../../../images/industry-community.png";
import CommunityCard from "./CommunityCard";

const communityList = [
    {
        name:'Ecoalliance',
        desc: 'For environmentally minded businesses',
        headImg: nr,
        slug: 'eco-alliance',
        url: '/community/eco-alliance/',
        header_link:'zuahaza'
    },
    {
        name:'Creatives',
        desc: "Illustrators, designers, agencies and beyond",
        headImg: is,
        slug: 'hash-creativecommunity',
        url: '/community/creative-community/',
        header_link:'evacoutodesign'
    },
    {
        name:'Industry Experts',
        desc: "The best in the business at all things ecommerce",
        headImg: bt,
        slug: 'industry-experts',
        url: '/community/industry-experts/',
        header_link:'laceandpearlsblog'
    },
    {
        name:'#itsnoissue',
        desc: "Join the noissue team",
        headImg: cb,
        slug: 'itsnoissue-team',
        url: '/community/itsnoissue/',
        header_link:'zuahaza'
    }
]

const WrapCommunitySection = () => {

    return (
            <section
                css={css`
                    height: 46rem;
                    width: 100%;
                    position: relative;
                    background: linear-gradient( 180deg, #EBF4FA 81.08%, #EBF4FA 100%);
                    `}
            >
                <div css={css`
                    padding: 4rem 0;
                `}>

                <h1 css={css`
                    color: #393972;
                    font-size: 8rem;
                    text-align: center;
                    line-height: 10rem;
                    padding: 0 1rem;
                    @media(max-width: 1024px){
                        font-size: 5rem;
                        line-height: 5rem;
                    }
                    @media(max-width: 375px){
                        font-size: 4rem;
                        line-height: 4rem;
                    }
                `}>
                    Our Communities
                </h1>
                {/* <p css={css`
                    color: #FD566F;
                    text-align: center;
                    font-weight: 600;
                    font-size: 1.6rem;
                `}>
                    #noissuepackaging
                </p> */}
                <div css={css`
                    display: flex;
                    flex-direction: row;
                    justify-content: start;
                    margin-top: 7rem;
                    max-width: 96rem;
                    padding: 2rem 0;
                    margin: auto;
                    overflow-y: auto;
                `}>
                    {communityList.map((item, index) =>
                        <CommunityCard post={item} id={index} />
                    )}
                </div>
                </div>
            </section>
    );
};

export default WrapCommunitySection;
